module.exports = __webpack_public_path__ + "img/free-fire-vpn.5dbf8474.webp";